import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { amtNumStr, amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import {
  useGetUsersByAccountAndSoftwareQuery,
  UserSelection,
} from 'generated/graphql'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router'
import { RevaluationDetailContent } from './RevaluationDetailContent'
import TextSeparator from '@ifca-root/react-component/src/components/Typography/TextSeparator'

export const RevaluationDetail = (props: any) => {
  const history = useHistory()
  const { CompanyID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const location = useLocation()
  const editData = location?.state as any

  const {
    loading: getUsersByAccountAndSoftwareLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    variables: {
      superUserBool: UserSelection.All,
    },
  })

  const getRevaluationIndicator = () => {
    const surplus = parseFloat(editData?.revaluation_surplus || 0)
    const deficit = parseFloat(editData?.revaluation_deficit || 0)

    if (surplus > 0) {
      return <span style={{ color: 'green' }}>Surplus: {amtStr(surplus)}</span>
    } else if (deficit > 0) {
      return <span style={{ color: 'red' }}>Deficit: {amtStr(deficit)}</span>
    }
    return <span style={{ color: '#666' }}>No Changes</span>
  }

  return (
    <>
      {getUsersByAccountAndSoftwareLoading && <Loading />}

      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/fixed-assets/${CompanyID}/revaluation`)
        }}
        smTitle="Fixed Assets"
        title={user?.companyName}
        routeSegments={[
          { name: 'Fixed Assets' },
          { name: 'Revaluation' },
          { name: 'Detail', current: true },
        ]}
      />

      <DynamicSubHeader
        title={
          <span className="xsTitle flex-space">
            <span style={{ fontWeight: 'bold' }}>{editData?.Asset?.name}</span>
          </span>
        }
        rightText={<span className="xsTitle">{editData?.DocNo}</span>}
        infoLine={
          <>
            <div className="desc flex-space">
              {formatDate(editData?.revaluation_date)}
            </div>
          </>
        }
        rightInfoLine={
          <span className="desc">
            {`${amtStr(editData?.net_amount_before)}`}
            <span> → </span>
            <span style={{ color: 'orange' }}>
              {amtStr(editData?.net_amount_after)}
            </span>
            <TextSeparator />
            {getRevaluationIndicator()}
          </span>
        }
      />

      <ContentWrapper multiDynamicInfo float>
        <CardContents>
          <RevaluationDetailContent
            listEl={editData}
            listStatus={editData?.ApprovalStatus}
            userList={getUsersByAccountAndSoftware}
            mode={'detail'}
          />
        </CardContents>
      </ContentWrapper>
    </>
  )
}
